import { shipmentApiClient } from '../shipmentApiClient'
import { bookingCandidatesEndpoint } from './endpoint'
import type { GetBookingCandidatesParams, GetBookingCandidatesResponse } from './type'

export const getBookingCandidates = async (
  params: GetBookingCandidatesParams
): Promise<GetBookingCandidatesResponse> => {
  const res = await shipmentApiClient.post<GetBookingCandidatesResponse>(
    bookingCandidatesEndpoint,
    {
      deliveryReportUid: params.deliveryReportUid,
      driverPhone: params.driverPhone,
    }
  )
  return res.data
}
